import { DateFormat } from "../../../../../../constants";
import { StringHelper } from "../../../../../../helper";
import { AFLType } from "../../models";

export const form45 = (record: any) => {
  return {
    departmentCode: "3",
    aflType: AFLType.TerminationContractApplication,
    layout: [
      {
        type: "header",
        value: {
          form: 1,
          department: "CHI NHÁNH ĐÀ NẴNG",
        },
      },
      {
        type: "title",
        value: {},
      },
      {
        type: "salutation",
        value: ["Giám đốc Chi nhánh"],
      },
      {
        type: "content",
        value: [
          { type: "eRequestNameAndId", value: { name: record?.eRequestName, id: record?.eEmployeeId } },
          {
            type: "ePositionAndTeam",
            value: {
              position: StringHelper.verticalBarSplit<string[]>(record?.eTitle)[1],
              team: StringHelper.verticalBarSplit<string[]>(record?.eUnit)[1],
            },
          },
          {
            type: "eDoBAndSabre",
            value: {
              dob: record?.eEmployeeBirthday?.format(DateFormat.DD_MM_YYY) || "",
              sabre: record?.eCodeSabre || "",
            },
          },
          {
            type: "eAddress",
            value: record?.eAddress || "",
          },
          {
            type: "eBusinessTime",
            value: record?.eBusinessTime || "",
          },
          {
            type: "eLongReasonSingleDate",
            value: {
              reason: record?.eReason || "",
              place: record?.eLeavePlace || "",
              date: record?.eTerminationContractTime,
              title: "chấm dứt hợp đồng lao động",
              directorTitle: "Giám đốc Chi nhánh",
            },
          },
          {
            type: "",
            value: `Tôi xin cam đoan trả lại Công ty/chi nhánh các trang thiết bị, vật tư, công cụ dụng cụ (nếu được cấp), thẻ công tác và thực hiện các thủ tục thanh toán chấm dứt Hợp đồng lao động theo đúng quy định của Công ty và của Pháp luật hiện hành. `,
          },
          { type: "", value: "Tôi xin trân trọng cảm ơn !" },
        ],
      },
      {
        type: "dateSection",
        value: "",
      },
      {
        type: "footer",
        value: [
          {
            type: "signature1",
            value: ["Ý KIẾN BỘ PHẬN", record?.eSteps[1][0].name],
          },
          {
            type: "signature1",
            value: ["NGƯỜI LÀM ĐƠN", record?.eRequestName],
          },
        ],
        textBreak: 1,
      },
      {
        type: "footer",
        value: [
          {
            type: "signature1",
            value: ["PHÊ DUYỆT CỦA GIÁM ĐỐC", record?.eSteps[3][0].name],
          },
          {
            type: "signature1",
            value: ["Ý KIẾN PHÒNG KHHC", record?.eSteps[2][0].name],
          },
        ],
        textBreak: 1,
      },
    ],
  };
};
